import { css } from "styled-components"

export default css`
  background: linear-gradient(to bottom, #102948 0%, #102031 100%);
  box-shadow: #0000006e 4px 4px 25px;
  position: relative;
`
